import { registerEmailDatafields } from './emailDatafields';

let loading;

const inlineReplyStyles = `
  body { overflow-wrap: anywhere; }
  @media screen and (max-width: 600px) {
    html { width: 100% !important; min-width: 0 !important; max-width: 100% !important; overflow-x: hidden !important; }
    body { box-sizing: border-box; width: auto !important; min-width: 0 !important; max-width: 100% !important; overflow-x: auto !important; overflow-wrap: anywhere !important; }
    table { box-sizing: border-box; width: 100% !important; min-width: 0 !important; max-width: 100% !important; table-layout: auto; }
    table * { box-sizing: border-box; max-width: 100% !important; }
    td, th { min-width: 0 !important; max-width: 100% !important; overflow-wrap: anywhere; word-break: break-word; }
    img { min-width: 0 !important; max-width: 100% !important; height: auto !important; }
    pre, code { white-space: pre-wrap !important; overflow-wrap: anywhere !important; }
  }
`;

window.loadFroala = (ready, failure) => {
  if ($.FE) {
    ready();
    return;
  }
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = window.froalaKey.scriptUrl;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  loading.then(ready, () => {
    if (failure) failure();
    errorAlert(
      'Unable to load the email editor. Please refresh the page and try again.'
    );
  });
};

const registerCommands = () => {
  if ($.FE.COMMANDS.emailDatafield) return;

  registerEmailDatafields();
  const command = (name, title, callback, extra = {}) => {
    $.FE.DefineIcon(name, { NAME: title, template: 'text' });
    $.FE.RegisterCommand(name, {
      title,
      focus: true,
      undo: true,
      callback,
      ...extra,
    });
  };
  command(
    'showBlocks',
    'Show Blocks',
    function () {
      const current = this.pmShowBlocksStyle;
      if (current && current.isConnected) current.remove();
      else {
        const style = this.doc.createElement('style');
        style.setAttribute('data-fr-style', 'true');
        style.textContent =
          'body :is(p,div,h1,h2,h3,h4,h5,h6,blockquote,pre) { outline:1px dashed currentColor; }';
        this.doc.head.appendChild(style);
        this.pmShowBlocksStyle = style;
      }
    },
    { undo: false }
  );
  command('createDiv', 'Create Div', function () {
    this.paragraphFormat.apply('DIV');
  });
  ['ltr', 'rtl'].forEach((direction) => {
    command(
      `paragraph${direction.toUpperCase()}`,
      direction.toUpperCase(),
      function () {
        this.selection
          .blocks()
          .forEach((block) => block.setAttribute('dir', direction));
      }
    );
  });
  command(
    'lineHeight',
    'Line Height',
    function (_command, value) {
      this.selection.blocks().forEach((block) => {
        block.style.lineHeight = value;
      });
    },
    {
      type: 'dropdown',
      options: {
        1: 'Single',
        1.15: '1.15',
        1.5: '1.5',
        2: 'Double',
        2.5: '2.5',
        3: '3',
      },
    }
  );
  command(
    'emailStyles',
    'Styles',
    function (_command, value) {
      const blockStyles = {
        italicTitle: ['H2', 'font-style:italic'],
        subtitle: ['H3', 'color:#aaa;font-style:italic'],
        specialContainer: [
          'DIV',
          'padding:5px 10px;background:#eee;border:1px solid #ccc',
        ],
      };
      if (blockStyles[value]) {
        const [tag, style] = blockStyles[value];
        this.paragraphFormat.apply(tag);
        this.selection.blocks().forEach((block) => {
          block.style.cssText += `;${style}`;
        });
      } else if (value === 'marker') {
        this.format.apply('span', { class: 'marker' });
      } else if (value === 'rtl' || value === 'ltr') {
        this.format.apply('span', { dir: value });
      } else if (value === 'leftImage' || value === 'rightImage') {
        const image = this.image.get();
        if (image)
          image.css({
            float: value === 'leftImage' ? 'left' : 'right',
            margin: '5px',
          });
      } else if (value === 'compactTable' || value === 'borderlessTable') {
        const table = $(this.selection.element()).closest('table');
        if (value === 'compactTable')
          table
            .attr({
              cellpadding: '5',
              cellspacing: '0',
              border: '1',
              bordercolor: '#ccc',
            })
            .css('border-collapse', 'collapse');
        else
          table.css({
            'border-style': 'hidden',
            'background-color': '#E6E6FA',
          });
      } else if (value === 'squareList') {
        $(this.selection.element())
          .closest('ul')
          .css('list-style-type', 'square');
      } else {
        this.format.apply(value);
      }
    },
    {
      type: 'dropdown',
      options: {
        italicTitle: 'Italic Title',
        subtitle: 'Subtitle',
        specialContainer: 'Special Container',
        marker: 'Marker',
        big: 'Big',
        small: 'Small',
        tt: 'Typewriter',
        code: 'Computer Code',
        kbd: 'Keyboard Phrase',
        samp: 'Sample Text',
        var: 'Variable',
        del: 'Deleted Text',
        ins: 'Inserted Text',
        cite: 'Cited Work',
        q: 'Inline Quotation',
        rtl: 'Language: RTL',
        ltr: 'Language: LTR',
        leftImage: 'Styled Image (left)',
        rightImage: 'Styled Image (right)',
        compactTable: 'Compact Table',
        borderlessTable: 'Borderless Table',
        squareList: 'Square Bulleted List',
      },
    }
  );
};

window.froalaEditorConfig = (options = {}) => {
  registerCommands();
  const toolbar = [
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'subscript',
    'superscript',
    'clearFormatting',
    '|',
    'formatOL',
    'formatUL',
    'outdent',
    'indent',
    'quote',
    'createDiv',
    'align',
    'paragraphLTR',
    'paragraphRTL',
    '-',
    'emailStyles',
    'paragraphFormat',
    'fontFamily',
    'fontSize',
    'color',
    'lineHeight',
    '|',
    'insertLink',
    'insertImage',
    'insertTable',
    'html',
    'fullscreen',
    'showBlocks',
    'undo',
    'redo',
    ...(options.emailDatafields ? ['emailDatafield'] : []),
  ];
  return {
    key: window.froalaKey.key,
    theme: document.body.classList.contains('theme-dark1') ? 'froala_dark' : '',
    fullPage: true,
    iframe: true,
    htmlUntouched: true,
    htmlAllowedTags: ['.*'],
    htmlAllowedAttrs: ['(?!on).*'],
    htmlAllowedEmptyTags: [
      'textarea',
      'a',
      'iframe',
      'object',
      'video',
      'style',
      'script',
      'email_datafield',
    ],
    htmlRemoveTags: ['script'],
    htmlExecuteScripts: false,
    useClasses: true,
    spellcheck: true,
    toolbarSticky: false,
    zIndex: 2000,
    toolbarButtons: toolbar,
    toolbarButtonsMD: options.toolbarButtons || toolbar,
    toolbarButtonsSM: options.toolbarButtons || toolbar,
    toolbarButtonsXS: options.toolbarButtons || toolbar,
    fontFamilySelection: true,
    fontFamily: {
      Arial: 'Arial',
      'Comic Sans MS': 'Comic Sans MS',
      'Courier New': 'Courier New',
      Georgia: 'Georgia',
      'Times New Roman': 'Times New Roman',
      'Trebuchet MS': 'Trebuchet MS',
      Verdana: 'Verdana',
    },
    fontSizeSelection: true,
    fontSize: [
      '8',
      '9',
      '10',
      '11',
      '12',
      '14',
      '16',
      '18',
      '20',
      '22',
      '24',
      '26',
      '28',
      '36',
      '48',
      '72',
    ],
    quickInsertTags: [],
    charCounterCount: false,
    codeMirror: false,
    imagePaste: true,
    imageUpload: true,
    imageUploadRemoteUrls: false,
    height: 254,
    width: '100%',
    editorClass: 'pm-email-editor',
    ...options,
  };
};

window.initializeFroalaEditor = (element, options = {}) => {
  const $element = $(element);
  const originalHtml = element.value;
  const observer = new MutationObserver(() => {
    if (!element.isConnected) $element.froalaEditor('destroy');
  });
  $element.on('froalaEditor.destroy.pmEditor', () => {
    observer.disconnect();
    $element.off('.pmEditor');
  });
  $element.on('froalaEditor.html.beforeGet.pmEditor', (_event, editor) => {
    if (editor.opts.iframe) editor.$el.removeClass('fr-element');
  });
  $element.on('froalaEditor.html.afterGet.pmEditor', (_event, editor) => {
    if (editor.opts.iframe) editor.$el.addClass('fr-element');
  });
  $element.on(
    'froalaEditor.initialized.pmEditor froalaEditor.html.set.pmEditor',
    (_event, editor) => {
      editor.$el.addClass('fr-element');
      if (!editor.opts.iframe) return;
      if (editor.pmThemeStyle && editor.pmThemeStyle.isConnected) return;
      const style = editor.doc.createElement('style');
      style.setAttribute('data-fr-style', 'true');
      const hostStyle = window.getComputedStyle(element);
      style.textContent = `
      email_datafield { outline: 1px dotted currentColor; }
      ${editor.opts.theme === 'froala_dark' || options.inlineReply ? `html, body { background-color: ${hostStyle.getPropertyValue('--pm-surface') || hostStyle.getPropertyValue('--D2')} !important; color: ${hostStyle.getPropertyValue('--pm-text-primary') || hostStyle.getPropertyValue('--D16')} !important; }` : ''}
      ${options.inlineReply ? inlineReplyStyles : ''}
    `;
      editor.doc.head.appendChild(style);
      editor.pmThemeStyle = style;
    }
  );
  $element.on('froalaEditor.initialized.pmEditor', (_event, editor) => {
    if (editor.pmOriginalHtml === undefined) {
      editor.pmOriginalHtml = originalHtml;
      editor.pmOriginalSerialized = editor.html.get();
    }
  });
  $element.on(
    'froalaEditor.image.beforeUpload.pmEditor',
    (_event, editor, files) => {
      if (files.length) {
        const reader = new FileReader();
        reader.onload = (event) => {
          if ($element.data('froala.editor') === editor) {
            editor.image.insert(
              event.target.result,
              null,
              null,
              editor.image.get()
            );
          }
        };
        reader.readAsDataURL(files[0]);
      }
      editor.popups.hideAll();
      return false;
    }
  );
  $element.froalaEditor(window.froalaEditorConfig(options));
  observer.observe(element.ownerDocument.documentElement, {
    childList: true,
    subtree: true,
  });
  return $element.data('froala.editor');
};

window.email_compose_froala = (formId, entityType) => {
  window.loadFroala(() => {
    const element = document.getElementById(`${formId}_body`);
    if (!element) return;
    window.initializeFroalaEditor(element, {
      emailDatafields: !!entityType,
      emailComposerEntityType: entityType,
    });
    $(`#${formId}`).on('ajax:before', () => {
      element.value = window.getFroalaHtml($(element).data('froala.editor'));
    });
  });
};

window.adjust_email_compose_froala = (formId) => {
  const element = document.getElementById(`${formId || 'email_template'}_body`);
  const editor = $(element).data('froala.editor');
  if (!editor) return;
  editor.opts.width = '100%';
  editor.size.refresh();
};

window.getFroalaHtml = (editor) => {
  const html = editor.codeView.isActive()
    ? editor.codeView.get()
    : editor.html.get();
  return html === editor.pmOriginalSerialized ? editor.pmOriginalHtml : html;
};

window.setFroalaHtml = (editor, html) => {
  if (editor.codeView.isActive()) editor.codeView.toggle();
  editor.html.set(html);
  // Froala serializes full-page HTML on load. Keep untouched stored mail byte-for-byte.
  editor.pmOriginalHtml = html;
  editor.pmOriginalSerialized = editor.html.get();
  editor.$oel.val(html);
};
